import React from 'react'
import { Button, Glyphicon } from 'react-bootstrap'
import useForm from '../../../hooks/useForm'

type Props = { addMapViewer: Function }

const translations = {
  name: 'Namn & Efternamn',
  email: 'Email',
  zip: 'Postnummer (t.ex. värdet "1;43;2" gör att användaren kan se projekt och leveranser till postnummer som börjar med 1 respektive 43 och 2)',
  password: 'Lösenord',
}

const defaultFormValues = Object.keys(translations).reduce((acc, key) => ({ ...acc, [key]: '' }), {})

const AddMapViewerBox = ({ addMapViewer }: Props) => {
  const [formValues, onFormChange, resetForm] = useForm(defaultFormValues)

  const { name, email, password } = formValues
  return (
    <div style={{ background: '#fff', marginBottom: 20, padding: 7 }}>
      {Object.entries(formValues).map(([key, value]) => (
        <div key={key} className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
          <label style={{ paddingRight: 21 }}>{`${translations[key]}:`}</label>
          <input onChange={onFormChange} name={key} className="change-input form-control" type="text" value={value} />
        </div>
      ))}
      <Button disabled={!name || !email || !password} onClick={() => addMapViewer(formValues).then(resetForm)} className="btn btn-primary" bsSize="small" style={{ backgroundColor: '#006e78' }} block>
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara tillgång
      </Button>
    </div>
  )
}

export default AddMapViewerBox
